import { render } from "./UserTipsPage.vue?vue&type=template&id=68673b57&scoped=true"
import script from "./UserTipsPage.vue?vue&type=script&lang=js"
export * from "./UserTipsPage.vue?vue&type=script&lang=js"

import "./UserTipsPage.vue?vue&type=style&index=0&id=68673b57&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68673b57"]])

export default __exports__